export default (id, $$subscriptions) => {
  if ($$subscriptions === undefined || $$subscriptions === null || $$subscriptions === false) return false;
// console.log($$subscriptions, id)
  if ($$subscriptions && $$subscriptions.size && $$subscriptions.contains(id))
    return true;
  else if ($$subscriptions && $$subscriptions.indexOf && $$subscriptions.indexOf(id) >= 0)
    return true;
  else return false;
};



// WEBPACK FOOTER //
// ./src/helpers/isSubscribed.js